import React from 'react';
import PropTypes from 'prop-types';

const LoopOffPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M2.565 28.021L28.021 2.565l1.414 1.414L3.979 29.435l-1.414-1.414zm9.654-24.74a.748.748 0 0 1 1.062 0l4.012 4.012a1 1 0 0 1 0 1.414l-4.012 4.013A.75.75 0 0 1 12 12.189V10H9a3 3 0 0 0-3 3v6c0 1.051.54 1.975 1.358 2.511l-2.854 2.854A6.984 6.984 0 0 1 2 19v-6a7 7 0 0 1 7-7h3V3.811a.75.75 0 0 1 .219-.53zm12.483 7.248l2.849-2.847A6.98 6.98 0 0 1 30 13v6a7 7 0 0 1-7 7h-3v2.189a.751.751 0 0 1-1.281.53l-4.012-4.012a.999.999 0 0 1 0-1.414l4.012-4.013a.752.752 0 0 1 1.281.531V22h3a3 3 0 0 0 3-3v-6a3 3 0 0 0-1.298-2.471z"
    />
  );
};

LoopOffPath.propTypes = {
  fill: PropTypes.string,
};

export default LoopOffPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/loop-off.jsx